import React from "react";

export function MosaicSeedIcon({ size = 18, color = "currentColor", variant = "outline" }) {
  if (variant === "filled") {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="12" cy="12" r="6" fill={color} />
        <circle cx="12" cy="12" r="3" fill="white" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 2L19 6V14L12 22L5 14V6L12 2Z" stroke={color} strokeWidth="1.7" />
      <path d="M12 6V18" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
      <path d="M8 10L12 12L16 10" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function MosaicBridgeIcon({ size = 18, color = "currentColor", variant = "outline" }) {
  if (variant === "filled") {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="4" y="6" width="16" height="12" rx="4" fill={color} />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M3 16H21" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
      <path d="M6 16C6 11.5 8.6 8 12 8C15.4 8 18 11.5 18 16" stroke={color} strokeWidth="1.7" />
      <path d="M9 16V13M12 16V12M15 16V13" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

export function MosaicOrbitIcon({ size = 18, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="2.5" fill={color} />
      <path d="M4 12C4 8.4 7.6 6 12 6C16.4 6 20 8.4 20 12C20 15.6 16.4 18 12 18C7.6 18 4 15.6 4 12Z" stroke={color} strokeWidth="1.6" />
      <path d="M12 4C15.6 4 18 7.6 18 12C18 16.4 15.6 20 12 20C8.4 20 6 16.4 6 12C6 7.6 8.4 4 12 4Z" stroke={color} strokeWidth="1.2" opacity="0.7" />
    </svg>
  );
}
